module.exports = __webpack_public_path__ + "static/assets/dccd5059320d172d1b282564e0d9422d.svg";